export default {"src":"/_next/static/media/ic-powerpoint.2e67a5b6.svg","height":480,"width":480,"blurWidth":0,"blurHeight":0};